export default __webpack_public_path__ + "static/media/php.842ef02b.png";